namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_color_pick, {
		
		Bubble: {
			background: {
				color: 'transparent',
			},
			boxShadow: 'none',
		},
		
	} )
	
}
